<template>
    <div class="base-time-estimate">
        <BaseIcon
            class="dn-icon--square"
            icon="clock"
        />
        {{ time }}
    </div>
</template>
<script setup lang="ts">
defineProps<{
    time: string;
}>();
</script>
<style lang="less" src="./BaseTimeEstimate.less"></style>
